import type { BetSelection } from '../../types/domain';
import { events } from '../../data/fixtures';
import { Icon } from '../Icon';

interface BetSlipProps {
  selections: BetSelection[];
  onRemove: (oddId: string) => void;
  onClear: () => void;
  onRegister: () => void;
}

export function BetSlip({ selections, onRemove, onClear, onRegister }: BetSlipProps) {
  const total = selections.reduce((value, selection) => value * selection.value, 1);
  return (
    <aside className="right-sidebar" aria-label="Bet slip">
      <section className="betslip">
        <div className="betslip__tabs" role="tablist" aria-label="Bet slip views">
          <button className="betslip__tab is-active" role="tab" aria-selected="true">Bet slip <span>{selections.length || ''}</span></button>
          <button className="betslip__tab" role="tab" aria-selected="false">My bets</button>
        </div>
        {selections.length === 0 ? (
          <div className="betslip-empty">
            <span className="betslip-empty__icon"><Icon name="ticket" /></span>
            <strong>Your bet slip is empty</strong>
            <p>Click an odd to add a selection here.</p>
          </div>
        ) : (
          <div className="betslip__content">
            <div className="betslip__top"><span>Selections</span><button type="button" onClick={onClear}>Clear all</button></div>
            {selections.map((selection) => (
              <article className="bet-selection" key={selection.oddId}>
                <button className="bet-selection__remove" type="button" onClick={() => onRemove(selection.oddId)} aria-label={`Remove ${selection.eventLabel}`}><Icon name="close" /></button>
                <strong>{selection.eventLabel}</strong>
                <span>{selection.marketLabel} · {selection.oddLabel}</span>
                <b>{selection.value.toFixed(2)}</b>
              </article>
            ))}
            <label className="stake-field"><span>Stake</span><input inputMode="decimal" defaultValue="10.00" aria-label="Stake amount" /></label>
            <div className="betslip__return"><span>Total odds</span><strong>{total.toFixed(2)}</strong></div>
            <button className="primary-button betslip__place" type="button" onClick={onRegister}>Register to place bet</button>
          </div>
        )}
      </section>
      <section className="app-widget">
        <span className="app-widget__eyebrow">22Play mobile apps</span>
        <strong>A whole world of events in your pocket</strong>
        <NavButton />
        <div className="app-widget__phone" aria-hidden="true"><span /><span /><span /></div>
      </section>
      <section className="top-events-widget">
        <header>Top events</header>
        {events.slice(0, 3).map((event) => (
          <article key={event.id}>
            <span>{event.startTime}</span>
            <strong>{event.homeTeam}</strong>
            <strong>{event.awayTeam}</strong>
            <button type="button">{event.markets[0].odds[0].value?.toFixed(2)}</button>
          </article>
        ))}
      </section>
    </aside>
  );
}

function NavButton() {
  return <a className="secondary-button" href="#mobile-apps">Find out more</a>;
}
